// Import Tailwind
import './src/styles/global.css';
// Use React Contexts
import wrapWithProviders from './wrap-with-providers';

export const wrapRootElement = wrapWithProviders;
